import {
  Accordion,
  AccordionDetails,
  Button,
  Paper,
  Stack,
  Typography,
  styled,
} from "@mui/material";
import { ShareIcon } from "../icons/ShareIcon";

export const DropDownRedArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path
        d="M0.75 3.62L6 9.5L11.25 3.62"
        stroke="#FC4C4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  width: "100%",
  padding: 0,
  margin: "0",
  background: theme.palette.background.default,
  color: theme.palette.text.primary,
  "&:before": {
    display: "none",
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
}));

export const StyledLabel = styled(Typography)({
  color: "var(--Neutral-500, #7B858B)",
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "14px",
});

export const StyledCancelledText = styled(Typography)({
  color: "var(--primary-salmon-500-p, #FC4C4C)",
  textAlign: "center",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "14px",
});

export const StyledTableTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "14px",
}));

export const StyledContentHightLight = styled("div")(({ theme }) => ({
  padding: "12px 15px",
  borderRadius: "12px",
  border:
    theme.palette.mode === "light"
      ? `1px solid var(--Secondary-Ivory-500, #F4DEB6)`
      : `1px solid #5e5e5e`,
  background:
    theme.palette.mode === "light"
      ? `1px solid var(--Secondary-Ivory-500, #F4DEB6)`
      : `1px solid #5e5e5e`,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

export const TableContainer = styled("div")({
  boxShadow: "0px 4px 20px 0px rgba(173, 192, 203, 0.30)",
  padding: "24px 12px",
  borderRadius: "20px",
});

export const StyledAccordionDetails = styled(AccordionDetails)({
  padding: "12px",
  margin: 0,
  border: "1px solid #E5E7E8",
  borderRadius: "12px",
});

export const StyledRedHelperText = ({ text }: { text: string }) => {
  const StyledRedHelperText = styled(Typography)({
    color: "var(--primary-salmon-500-p, #FC4C4C)",
    textAlign: "center",
    fontFamily: "Söhne",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "17px",
    textDecorationLine: "underline",
  });

  return (
    <Stack
      direction={"row"}
      spacing="8px"
      textAlign={"center"}
      justifyContent={"center"}
      sx={{ cursor: "pointer" }}>
      <StyledRedHelperText>{text}</StyledRedHelperText>
      <ShareIcon />
    </Stack>
  );
};

export const StyledHelperContainer = styled("div")({
  borderRadius: "10px",
  background: "#F8F9F9",
  padding: "24px 32px",
  display: "flex",
  flexDirection: "column",
  gap: "6px",
});

export const StyledHelperTitle = styled(Typography)({
  color: "#000",
  textAlign: "center",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "19px",
  letterSpacing: "-0.32px",
});
export const StyledHelperLabel = styled(Typography)({
  color: "#000",
  textAlign: "center",
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "17px",
});

export const StyledModalContent = styled(Paper)({
  padding: "24px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "16px",
});

export const StyledModalTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "Roobert",
  fontSize: "23px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "28px",
  letterSpacing: "-0.46px",
}));

export const StyledDivider = styled("div")({
  margin: "20px 0px",
  borderBottom: "1px solid #F8F9F9",
});
export const StyledModalWarningText = styled(Typography)({
  color: "var(--primary-salmon-500-p, #FC4C4C)",
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "17px",
});

export const StyledCancelButton = styled(Button)(({ theme }) => ({
  borderRadius: "4px",
  textTransform: "none",
  fontSize: "14px",
  background: theme.palette.primary.contrastText,
}));

export const StyledTab = styled(Typography)(
  ({ theme, selected }: { theme?: any; selected: boolean }) => {
    let baseTabStyle = {
      color: theme.palette.text.primary,
      fontFamily: "Söhne",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "400",
      borderBottom: "1px solid transparent",
      cursor: "pointer",
    };

    if (selected) {
      baseTabStyle = {
        ...baseTabStyle,
        color: theme.palette.text.primary,
        borderBottom: `1px solid #FC4C4C`,
      };
    }

    return baseTabStyle;
  },
);

export const StyledFilterLabel = styled(Typography)({
  color: "var(--Neutral-500, #7B858B)",
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  marginBottom: "4px",
});
